<ng-container>
  <div class="description-text">
    <p class="mt-1 text-small mb-2">
      <span>{{ completedAmountOfTrainings() ? completedAmountOfTrainings() : 0 }}</span>
      von {{ expectedAmountOfTrainings() }} Trainings
    </p>

    <p class="mt-1 mb-2 text-small">
      <span>abgeschlossen</span>
    </p>
  </div>

  <div class="progress-indicators">
    @for (_ of expectedAmountOfTrainingsArr(); track $index; let i = $index; let count = $count) {
      <div
        class="indicator"
        [style.width.%]="100 / (count || 1)"
        [ngClass]="{'is-filled': i < completedAmountOfTrainings()}"></div>
    }
  </div>
</ng-container>
